import {none, Option, option} from "ts-option";
import {store} from "../../navigation/ReduxProvider";
import DictionaryItem from "../../model/dictionary/DictionaryItem";

/**
 * Gets Job type.
 * @param {string} id Job type identifier to get.
 * @returns {Option<DictionaryItem>} JobType.
 */
export function getJobTypeAsDictionaryItem(id: string): Option<DictionaryItem> {
	const types = store.getState().jobType.jobTypes.getOrElse([]);
	const type = types.filter((jt) => jt.id == id);
	if(type[0]) {
		return option(new DictionaryItem(type[0].id, type[0].name));
	}
	return none;
}